import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import MaterialTable from "material-table";
import { Link, withRouter } from "react-router-dom";
import { MANAGED_APPS, createInfoUrl } from "../utils/routes";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import _ from "lodash";
import store from "store";
import { isCurrentUserSuperAdmin } from "../utils/userRoles";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Chip from '@material-ui/core/Chip';
import { AddNewButton } from "./AddNewButton";

const styles = theme => ({
    pageTitle: {
        fontWeight: "bold",
        fontSize: "1.6em",
        marginBottom: theme.spacing(2)
    },
    appVersionRow: {
        backgroundColor: theme.palette.background.default
    },
    appVersionCell: {
        paddingTop: 4,
        paddingBottom: 0
    },
    link: {
        color: theme.palette.info.main,
        textDecoration: 'none',
        '&:hover': {
            backgroundColor: theme.palette.hoverBG,
        }
    },
    pageSubTitle: {
        marginTop: theme.spacing(1)
    },
});

class AppsTable extends Component {
    getStoredRowsPerPage = () => {
        let key = 'rowsPerPage_Apps';
        let defaultValue = 25;
        return store.get(key, defaultValue);
    }

    // isOpenTopLevelRow = (rowData, rowType) => {
    //     if (rowType === 'subrow') return false;
    //     return !!_.get(rowData, 'tableData.showDetailPanel');
    // }

    getColumns = () => {
        let { classes } = this.props;

        let columns = [
            {
                title: 'Icon',
                field: 'iconUrl',
                render: (rowData, rowType) => <img src={rowData.iconUrl} style={{ width: rowType === "subrow" ? 40 : 50 }} />
            },
            {
                title: 'Title',
                field: 'title',
                render: (rowData, rowType) => <Link className={classes.link} to={createInfoUrl(MANAGED_APPS, rowData._id)}>{rowData.title || '—'}</Link>,
            },
            {
                title: 'Package Name',
                field: 'packageName',
                render: (rowData, rowType) => rowData.packageName || '—',
            },
            {
                title: 'Version Code',
                field: 'latestVersion',
                render: (rowData, rowType) => rowData.latestVersion || '—',
            },
            {
                title: 'Version Name',
                field: 'versionName',
                render: (rowData, rowType) => rowData.versionName || '—',
            },
            {
                title: '',
                field: 'isPrimaryVersion',
                render: (rowData, rowType) => rowData.defaultVersion ? <Chip label="Default Version" size="small" /> : ""
            }
        ]

        if (isCurrentUserSuperAdmin()) {
            columns.push({
                title: `Organization`,
                field: 'organizationRef',
                render: (app) => app.organizationRef.id || '—',
            });
        }

        return columns;
    }

    getTableData = () => {
        let data = _.filter(Object.values(this.props.apps), (app) => !!app.apkUrl && !app.defaultVersionClone); // get all managedApps
        data = _.groupBy(data, (app) => {
            return app.packageName + app.organizationRef.id;  // group by packageName and org
        });
        data = _.map(Object.values(data), appVersions => {
            appVersions = _.orderBy(appVersions, ['latestVersion', 'versionName'], ['desc', 'desc']);
            let defaultApp = appVersions[0];
            for (let i = 0; i < appVersions.length; i++) {
                if (appVersions[i].defaultVersion) defaultApp = appVersions[i];
            }
            if (!defaultApp.tableData) defaultApp.tableData = {};
            defaultApp.tableData.appVersions = appVersions;
            return defaultApp
        });
        return data;
    }

    onChangeRowsPerPage = (numRows) => {
        let key = 'rowsPerPage_Apps';
        store.set(key, numRows);
    }

    render() {
        // console.log("RENDER (App Table)");

        let {
            classes,
            apps,
            history,
            onAddNewClick,
        } = this.props;

        let pageSize, pageSizeOptions;
        pageSize = this.getStoredRowsPerPage();
        pageSizeOptions = [10, 25, 50];

        let columns = this.getColumns();
        let data = this.getTableData();

        return (
            <div>
                <Grid container justify="space-between">
                    <Grid item xs={12}>
                        <Typography variant="h5" className={classes.pageTitle}>
                            Managed Apps
                            <AddNewButton onClick={onAddNewClick} title={"New Managed App"} />
                        </Typography>
                        <Typography variant="subtitle2" className={classes.pageSubTitle}>
                            Managed Apps are any custom application that your organization wants to make avaliable to the devices.
                            These apps are stored in the cloud and can be automatically installed, updated, and removed over the internet.
                            Once a device is given access to a managed app, it will install it as soon as it connected to the internet.
                        </Typography>
                    </Grid>
                </Grid>

                <Paper>
                    <MaterialTable
                        key={"default"}
                        title="Managed Apps"
                        columns={columns}
                        data={data}
                        icons={{
                            SortArrow: ArrowUpwardIcon
                        }}
                        onChangeRowsPerPage={this.onChangeRowsPerPage}
                        options={{
                            sorting: true,
                            pageSize: pageSize,
                            pageSizeOptions: pageSizeOptions,
                            padding: 'dense',
                            showTitle: false,
                            toolbarButtonAlignment: 'right',
                            draggable: false,
                            emptyRowsWhenPaging: false,
                        }}
                        components={{
                            Container: Box
                        }}
                        detailPanel={[
                            {
                                tooltip: 'Show All Versions',
                                render: (rowData) => {
                                    return (
                                        <>
                                            {rowData.tableData.appVersions.map((appData, i) =>
                                                <TableRow className={classes.appVersionRow} key={`appstable_row_${appData.packageName}${i}`}>
                                                    <TableCell padding='none'></TableCell>
                                                    {columns.map((column, i) =>
                                                        <TableCell key={`appstable_cell_${appData.packageName}${i}`} className={classes.appVersionCell} style={{ textAlign: i === 0 ? 'center' : 'left' }}>{column.render(appData, 'subrow')}</TableCell>
                                                    )}
                                                </TableRow>
                                            )}
                                        </>
                                    )
                                },
                            }
                        ]}
                    />
                </Paper>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    apps: state.data.apps,
    organizations: state.data.organizations
});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(withRouter(AppsTable)));
